import React from "react";
import {connect} from "react-redux";
import Section from "./Section";
import PRCopyright from "./PRCopyright";
import ScrollingList from "./ScrollingList";
import {getSections} from "../../../../redux/selectors/sections";
//import {getCurrentSectionIdBeingScrolled} from "../../../../redux/selectors/navigation";
import {isSearchActive} from "../../../../redux/selectors/search";

/**
 * ouptut list of sections/articles
 * @param  {} props
 * @return {}
 */
const ArticleList = (props) => {
    const {
        sections,
        sectionIdBeingScrolled,
        searchIsActive,
    } = props;

    if (searchIsActive) {
        return null;
    }

    if(sections.length) {
        return (
            <ScrollingList>
                {sections.map((section, index) =>
                    (<Section key={index} section={section}/>)
                )}
                <li><PRCopyright/></li>
            </ScrollingList>
        );
    } else {
        return (<PRCopyright/>);
    }
};

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {}
 */
const mapStateToProps = state => {
    return {
        sections: getSections(state),
        //sectionIdBeingScrolled: getCurrentSectionIdBeingScrolled(state),
        searchIsActive: isSearchActive(state),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {}
 */
const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ArticleList);
